module.exports = __webpack_public_path__ + "static/media/registered-mark.6143b8a3.svg";